module.exports = __webpack_public_path__ + "img/Weapon_282.a0c24744.png";